import { render, staticRenderFns } from "./projects_list.vue.js?vue&type=template&id=2f1d30d1!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./projects_list.vue?vue&type=template&id=2f1d30d1"
import script from "./projects_list.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./projects_list.vue?vue&type=script&lang=js"
export * from "./projects_list.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./projects_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f1d30d1')) {
      api.createRecord('2f1d30d1', component.options)
    } else {
      api.reload('2f1d30d1', component.options)
    }
    module.hot.accept("./projects_list.vue.js?vue&type=template&id=2f1d30d1!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./projects_list.vue?vue&type=template&id=2f1d30d1", function () {
      api.rerender('2f1d30d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/projects_list/projects_list.vue"
export default component.exports